import textFit from 'textfit';

common.View.create('vacancy::canvas.blocks.custom.headerText.Block', {

    onDOMLoad() {
       this.initAutoFit();
    },

    initAutoFit() {
        const settings = {
            alignVert: false, // if true, textFit will align vertically using css tables
            alignHoriz: false, // if true, textFit will set text-align: center
            multiLine: false, // if true, textFit will not set white-space: no-wrap
            detectMultiLine: false, // disable to turn off automatic multi-line sensing
            minFontSize: 35,
            maxFontSize: 300,
            reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
            widthOnly: true, // if true, textFit will fit text to element width, regardless of text height
            alignVertWithFlexbox: true, // if true, textFit will use flexbox for vertical alignment
        };

        textFit(this.element.find('.textDiv p'), settings);

        this.element.find('.textDiv p').css('white-space', 'normal');

        // Update textFit on window resize
        const debouncedResize = () => {

            // When Android opens the keyboard, the screen will resize and we have to restore the scroll top because of the plugin recalculating the font size.
            setTimeout(() => {

                let currentScrollTop = $('html')[0].scrollTop;

                console.info({currentScrollTop})

                textFit(this.element.find('.textDiv p'), settings);
                this.element.find('.textDiv p').css('white-space', 'normal');

                // Restore scroll offset.
                setTimeout(() => $('html')[0].scrollTop = currentScrollTop, 1);

            }, 100);

        };

        // Add the event listener for resize
        $(window).on('orientationchange', debouncedResize);
    },

    // Helper function to debounce another function
    debounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this, args = arguments;
            let later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
});
